/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RedoIcon = /*#__PURE__*/ createSvgIcon(
  'RedoIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M13.275 8.808H8.15a2.41 2.41 0 00-1.77.73 2.41 2.41 0 00-.73 1.77c0 .695.243 1.285.73 1.771a2.41 2.41 0 001.77.73h5.25c.208 0 .385.072.531.218a.723.723 0 01.219.531.723.723 0 01-.219.532.724.724 0 01-.531.218H8.15c-1.111 0-2.056-.389-2.833-1.166-.778-.778-1.167-1.723-1.167-2.834 0-1.11.389-2.055 1.167-2.833.777-.778 1.722-1.167 2.833-1.167h5.125l-1.417-1.416a.73.73 0 010-1.063.73.73 0 011.063 0l2.708 2.709c.07.069.122.149.156.24a.777.777 0 010 .562.682.682 0 01-.156.24l-2.708 2.707a.681.681 0 01-.521.22.758.758 0 01-.52-.24.73.73 0 010-1.063l1.395-1.396z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default RedoIcon;
